import { useContext } from 'react';

import tableContext from 'contexts/tableContext';

function useTable() {
  return useContext(tableContext);
}

export default useTable;
